<div class="container">
  <section class="home">
    <!-- //baner -->
    <!--
    <a
      class="masterclass"
      href="https://academia.broadfactor.com/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Masterclass gratuita: Crédito Estruturado para Contratos Governamentais, 20 de outubro às 19h"
    >
      <p class="masterclass__title">
        Você sabe o que analisar antes de aprovar crédito lastreado em
        <span>contratos governamentais?</span>
      </p>
      <div class="masterclass__event">
        <span class="masterclass__tag"
          >Masterclass <strong>gratuita</strong></span
        >
        <img
          class="masterclass__logo"
          src="./assets/img/cursos/LOGO - kv academia broadfactor - (1).png"
          alt="Crédito Estruturado para Contratos Governamentais"
        />
        <span class="masterclass__date">20 OUT <i></i> 19h</span>
      </div>
      <img
        class="masterclass__photo"
        src="./assets/img/cursos/Ricardo Cury (1).png"
        alt="Ricardo Cury, palestrante da masterclass"
      />
    </a>
    -->
    <div class="container__home">
      <div>
        <h1 class="home__title">Somos Broadfactor</h1>
        <p class="home__subtitle">
          Impulsionamos empreendedores brasileiros com antecipação de
          recebíveis, conta digital e conexões essenciais para transformar seu
          negócio e levá-lo mais longe.
        </p>

        <button
          mat-flat-button
          class="find-out-more-button"
          [routerLink]="['solucoes/antecipar-recebiveis']"
        >
          Saiba mais
        </button>
      </div>
      <img
        width="auto"
        height="auto"
        src="../../../assets/img/png/home-img.png"
        alt="Duas pessoas evidenciando o logo da Broadfactor"
        class="container-image home-image"
      />
    </div>
  </section>
  <app-carousel></app-carousel>

  <section class="container__info">
    <div class="container__info--width">
      <div class="container-info--text">
        <h2 class="home__title">Soluções que impulsionam o seu negócio</h2>
        <p class="home__subtitle">
          A Broadfactor conecta você às melhores soluções financeiras, como
          <strong>
            antecipação de recebíveis, AntecipaGov, BroadFactor Pay e Soluções
            personalizadas.</strong
          >
        </p>
      </div>
      <img
        width="300px"
        style="margin-right: 40px"
        src="./assets/img/png/foguete.png"
        alt="Foguete a frente de uma tela com dinheiro"
      />
    </div>
  </section>

  <section class="container-benefits">
    <div class="container-benefits__width">
      <div class="content-benefits">
        <div class="container-benefits__box">
          <h2>Solidez e confiança traduzidas em números</h2>
        </div>
        <div class="container-benefits__grid">
          <div class="container-benefits__box">
            <img alt="tempo de experiencia" src="./assets/img/png/relo.png" />
            <h3>+15 anos</h3>
            <span>de experiência</span>
          </div>
          <div class="container-benefits__box">
            <img alt="Crédito rápido" src="./assets/img/png/document.png" />
            <h3>+230 mil</h3>
            <span>Recebíveis antecipados </span>
          </div>
          <div class="container-benefits__box">
            <img alt="Baixa inadimplência" src="./assets/img/png/moeda.png" />
            <h3>+1B</h3>
            <span>Antecipações realizadas</span>
          </div>
          <div class="container-benefits__box">
            <img alt="Atendimento exclusivo" src="./assets/img/png/pd.png" />
            <h3>+3,5 mil</h3>
            <span>Empresas prosperando</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container__home">
    <div>
      <h2 class="title-history">Nossa História</h2>

      <img
        class="img-history"
        src="../../../assets/img/png/trajetoria.png"
        alt=""
      />
    </div>
  </section>

  <section class="container-benefits">
    <div class="container-benefits__width">
      <div class="content-benefits">
        <div class="container-benefits__box">
          <h2>
            Por que a Broadfactor é a escolha certa para impulsionar seu
            negócio?
          </h2>
        </div>
        <div class="container-benefits__grid">
          <div class="container-benefits__box">
            <img alt="tempo de experiencia" src="./assets/img/png/moni.png" />
            <h3>Totalmente online</h3>
            <span> Tudo de forma online e segura</span>
          </div>

          <div class="container-benefits__box">
            <img alt="Crédito rápido" src="./assets/img/png/coraçao.png" />
            <h3>Atendimento humanizado</h3>
            <span>Suporte rápido e exclusivo</span>
          </div>

          <div class="container-benefits__box">
            <img
              alt="Baixa inadimplência"
              src="./assets/img/png/dinheiro.png"
            />
            <h3>Crédito rápido</h3>
            <span>Ferramentas que conectam</span>
          </div>
          <div class="container-benefits__box">
            <img
              alt="Atendimento exclusivo"
              src="./assets/img/png/celular.png"
            />
            <h3>Análise inteligente</h3>
            <span>Recomendações Financeiras</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="home">
    <div class="container__home">
      <div>
        <h1 class="home__title">
          Seja um Broader se você sonha grande, nós sonhamos juntos.
        </h1>
        <p class="home__subtitle">
          Nossa
          <strong>
            missão é simples: descomplicar a vida do empreendedor.</strong
          >
          Venha fazer parte de uma equipe dinâmica e pronta para ir além!
        </p>

        <button
          mat-flat-button
          class="work-with-us-button"
          [routerLink]="['broadfactor/trabalhe-conosco']"
        >
          Trabalhe Conosco
        </button>
      </div>
      <img
        width="auto"
        height="auto"
        src="../../../assets/img/png/imagem t.png"
        alt="Foguete a frente de uma tela com dinheiro"
        class="container-image"
      />
    </div>
  </section>

  <section class="container__partners">
    <app-partners></app-partners>
  </section>
</div>
